<template>
    <li @click="changeLang(langId)">
        {{ langCode }}
    </li>
</template>

<script>
export default {
    props: [
        "langId", 
        "langCode"
    ],
    emits: ["changeLang"],
    methods: {
        changeLang(langId) {
            this.$emit("changeLang", langId);
        }
    }
}
</script>

<style scoped>
li {
    justify-content: center;
    margin: 0;
    height: 30px;
}

li:hover {
    background-color: var(--sniffer-color-border);
}
</style>